import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage, logApiError } from 'services/apiError'
import SecondaryButton from 'components/Buttons/SecondaryButton'
import Record from './Record'
import { Formik } from 'formik'

import {
  Container,
  Row,
  InfoText,
  Input,
  ButtonText,
  WarningText,
  ErrorContainer
} from './styles'

export default function RecordList ({
  records = [],
  customerID,
  onRecordAdded: handleRecordAdded,
  onDelete: handleDelete
}) {
  const [errorMessage, setErrorMessage] = useState (null)
  const token = AuthService.getToken ()
  const businessId = AuthService.getBusinessId ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  return (
    <Container>
      {records.length > 0 ? records.map (record => (
        <Record
          key={record.id}
          data={record}
          onDelete={handleDelete}
        />
      )) : (
        <InfoText>
          Este cliente ainda não possui anotações no prontuário
        </InfoText>
      )}
      {AuthService.hasPermission ('customers', 'edit') && (
        <Formik
          initialValues={{ 'description': '' }}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            try {
              const { data: record } = await cutileiApi.post ('/records', {
                customerId: customerID, businessId, ...values
              }, requestConfig)

              setSubmitting (false)
              resetForm ()
              handleRecordAdded (record)
            } catch (error) {
              setErrorMessage (getApiErrorMessage (error))
              setSubmitting (false)
              logApiError (error)
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit
          }) => (
            <Row>
              <Input
                placeholder='Novo registro'
                value={values.description}
                onChange={handleChange ('description')}
                onBlur={handleBlur ('description')}
              />
              {touched.description && errors.description && (
                <WarningText>
                  {errors.description}
                </WarningText>
              )}
              <SecondaryButton
                label='Registrar'
                onClick={handleSubmit}
                disabled={isSubmitting}
                loading={isSubmitting}
                width={200}
              />
            </Row>
          )}
        </Formik>
      )}
      {errorMessage && (
        <ErrorContainer>
          <ButtonText>{errorMessage}</ButtonText>
        </ErrorContainer>
      )}
    </Container>
  )
}
